import BaseResource from './index'
import UserResource from './user'

export default class MessageResource extends BaseResource {
    static endpoint = '/messages'
    static related = {
        to: UserResource,
        sender: UserResource
    }

    static async thread(betweenUserId, options = {}) {
        let wrapped = this.wrap('/thread')
        let result = await wrapped.get({ params: { sender: betweenUserId } })
        let content = this.client.negotiateContent(this)
        return content(result)
    }

    static async unreadCount(userId) {
        let result = await this.list({ params: { to: userId, read__isnull: 'True', page_size: 1 } })
        return result.count
    }

    async read() {
        let wrapped = this.wrap('/read')
        try {
            let result = await wrapped.patch()
            this.set('read', result.data.read)
            return true
        } catch(e) {
            return false
        }
    }
}
